import ShelfList from './ShelfList'

export default {
  ShelfList,
}
